// 권한 레벨 정의
export const ROLES = {
  STAFF: 'staff',
  MANAGER: 'manager',
  ADMIN: 'admin'
};

// 권한 레벨 우선순위
export const ROLE_PRIORITY = {
  [ROLES.STAFF]: 1,
  [ROLES.MANAGER]: 2,
  [ROLES.ADMIN]: 3
};

// 기능별 권한 정의 (요구사항 기반)
export const PERMISSIONS = {
  // 계약 관리 - Staff, Manager만 (Admin 제외)
  CONTRACT_VIEW: [ROLES.STAFF, ROLES.MANAGER],
  CONTRACT_SEARCH: [ROLES.STAFF, ROLES.MANAGER],
  CONTRACT_CREATE: [ROLES.MANAGER],
  CONTRACT_EDIT: [ROLES.MANAGER],
  CONTRACT_DELETE: [ROLES.MANAGER],
  
  // 비용 관리 - Manager만 (Admin 제외)
  COST_VIEW: [ROLES.MANAGER],
  COST_CREATE: [ROLES.MANAGER],
  COST_EDIT: [ROLES.MANAGER],
  COST_DELETE: [ROLES.MANAGER],
  COST_MANAGE: [ROLES.MANAGER],
  
  // 관리비 관리 - Manager만 (Admin 제외)
  MANAGEMENT_FEE_VIEW: [ROLES.MANAGER],
  MANAGEMENT_FEE_CREATE: [ROLES.MANAGER],
  MANAGEMENT_FEE_EDIT: [ROLES.MANAGER],
  MANAGEMENT_FEE_DELETE: [ROLES.MANAGER],
  MANAGEMENT_FEE_MANAGE: [ROLES.MANAGER],
  
  // 민원 관리 - Manager만 (Admin 제외)
  MAINTENANCE_VIEW: [ROLES.MANAGER],
  MAINTENANCE_CREATE: [ROLES.MANAGER],
  MAINTENANCE_EDIT: [ROLES.MANAGER],
  MAINTENANCE_DELETE: [ROLES.MANAGER],
  MAINTENANCE_MANAGE: [ROLES.MANAGER],
  
  // 메모 관리 - Staff, Manager만 (Admin 제외)
  MEMO_VIEW: [ROLES.STAFF, ROLES.MANAGER],
  MEMO_CREATE: [ROLES.STAFF, ROLES.MANAGER],
  // 메모 수정은 manager 이상 (manager, admin)
  MEMO_EDIT: [ROLES.MANAGER, ROLES.ADMIN],
  MEMO_DELETE: [ROLES.MANAGER],
  
  // 석물 관리 - Manager만 (Admin 제외)
  STONE_VIEW: [ROLES.MANAGER],
  STONE_CREATE: [ROLES.MANAGER],
  STONE_EDIT: [ROLES.MANAGER],
  STONE_DELETE: [ROLES.MANAGER],
  
  // 통계 관리 - Manager만 (Admin 제외)
  STATISTICS_VIEW: [ROLES.MANAGER],
  STATISTICS_MANAGE: [ROLES.MANAGER],
  
  // 주소 검색 - Staff, Manager만 (Admin 제외)
  ADDRESS_SEARCH: [ROLES.STAFF, ROLES.MANAGER],
  
  // 사용자 관리 - Admin 전용
  USER_MANAGE: [ROLES.ADMIN],
  USER_CREATE: [ROLES.ADMIN],
  USER_EDIT: [ROLES.ADMIN],
  USER_DELETE: [ROLES.ADMIN],
  
  // 시스템 관리 - Manager만 (Admin 제외)
  SYSTEM_MANAGE: [ROLES.MANAGER],
  SYSTEM_SETTINGS: [ROLES.MANAGER],
  
  // 묘지 관리 - Admin 전용
  CEMETERY_VIEW: [ROLES.ADMIN],
  CEMETERY_CREATE: [ROLES.ADMIN],
  CEMETERY_EDIT: [ROLES.ADMIN],
  CEMETERY_DELETE: [ROLES.ADMIN],
  
  // 관리자 페이지 - Manager만 (Admin 제외)
  ADMIN_PAGE_ACCESS: [ROLES.MANAGER],
};

// 권한 확인 함수
export const hasPermission = (userRole, permission) => {
  if (!userRole || !permission) return false;
  
  const allowedRoles = PERMISSIONS[permission];
  if (!allowedRoles) return false;
  
  return allowedRoles.includes(userRole);
};

// 권한 레벨 확인 함수
export const hasRole = (userRole, requiredRole) => {
  if (!userRole || !requiredRole) return false;
  
  const userPriority = ROLE_PRIORITY[userRole] || 0;
  const requiredPriority = ROLE_PRIORITY[requiredRole] || 0;
  
  return userPriority >= requiredPriority;
};

// 권한 기반 컴포넌트 래퍼
export const withPermission = (Component, permission) => {
  return (props) => {
    const { user } = props;
    
    if (!hasPermission(user?.role, permission)) {
      return null; // 권한이 없으면 렌더링하지 않음
    }
    
    return <Component {...props} />;
  };
};

// 권한 기반 버튼 컴포넌트
export const PermissionButton = ({ permission, user, children, ...props }) => {
  if (!hasPermission(user?.role, permission)) {
    return null;
  }
  
  return <button {...props}>{children}</button>;
}; 